/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2018-12-28 12:09:05
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-28 14:46:56
 */
import Vue from 'vue'
import {
    login,
    getUserOrg,
    getInfo,
    refreshToken
} from '@/api/login'
import { ORG } from '@/store/mutation-types'
import { welcome, setCookie } from '@/utils/util'
import { getCurAvatarUrl, setCurAvatar } from "@/api/account/person";
import store from '@/store'
const user = {
    state: {
        token: '',
        org: null,
        orgList: [],
        name: '',
        welcome: '',
        avatar: '',
        perm_list: [],
        info: {}
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_ORG: (state, org) => {
            state.org = org
            Vue.ls.set(ORG, org)
        },
        SET_ORG_LIST: (state, list) => {
            state.orgList = list
        },
        SET_NAME: (state, { name, welcome }) => {
            state.name = name
            state.welcome = welcome
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_PERM_LIST: (state, perm_list) => {
            state.perm_list = perm_list
        },
        SET_INFO: (state, info) => {
            state.info = info
        }
    },

    actions: {
        setOrg({
            commit, dispatch
        }, org) {
            commit('SET_ORG', org)
            dispatch('GetAvatar')
        },
        // 刷新token
        RefreshToken(
            { commit, state }
        ) {
            return new Promise((resolve, reject) => {
                refreshToken({ token: state.token }).then(res => {
                    const now = Date.parse(new Date())
                    const expire = state.info.token_exp * 1000
                    Vue.ls.set('TOKEN_CREATE_TIME', now, expire)
                    setCookie('token', res.token)
                    commit('SET_TOKEN', res.token)
                    // const count_down = (state.info.token_exp||0) * 1000
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 登录
        Login({
            commit
        }, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo).then(res => {
                    const now = Date.parse(new Date())
                    // 默认1小时，刷新时会使用实际的有效时间
                    const expire = 60 * 60 * 1000
                    Vue.ls.set('TOKEN_CREATE_TIME', now, expire)
                    setCookie('token', res.token)
                    commit('SET_TOKEN', res.token)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({ state, commit, dispatch }) {
            return new Promise((resolve, reject) => {
                getInfo().then(res => {
                    const perm_list = []
                    commit('SET_PERM_LIST', res.perm_list)
                    commit('SET_INFO', res)
                    commit('SET_NAME', {
                        name: res.nickname || res.username,
                        welcome: welcome()
                    })
                    if (!state.org) {
                        commit('SET_ORG', res.organizations[0] || {})
                    }
                    commit('SET_ORG_LIST', res.organizations || [])
                    dispatch('GetAvatar')
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取组织信息
        GetOrgs(
            { commit, state }
        ) {
            return new Promise((resolve, reject) => {
                getUserOrg().then((res) => {
                    const id = (state.org || {}).id
                    const corg = res.filter(item => item.id == id)
                    // 如果id存在并且在列表中则不进行任何操作，反之则取第一个组织

                    if (!res.length) {
                        commit('SET_ORG', {})
                        store.commit('SET_CURRENT_STEP', 'apply-org-1') // 没有组织的时候，开启申请加入组织的操作指引
                        resolve(res)
                    } else if (id && corg.length) { // 避免公司信息修改后，本地缓存未更新的问题
                        commit('SET_ORG', corg[0])
                        resolve(res)
                    } else {
                        const org = res[0] || {}
                        commit('SET_ORG', org)
                        resolve(res)
                    }

                }).catch(error => {
                    reject(error)
                })

            })
        },

        // 登出
        Logout(
            { commit, state }
        ) {
            return new Promise((resolve) => {
                commit('SET_TOKEN', '')
                commit('SET_PERM_LIST', [])
                setCookie('token', '')
                Vue.ls.remove('TOKEN_CREATE_TIME')
                Vue.ls.remove('STATUS_LIST')
                Vue.ls.remove('ORG')
                resolve()
                // logout(state.token).then(() => {
                // resolve()
                // }).catch(() => {
                // resolve()
                // })
            })
        },
        // 获取当前用户头像
        GetAvatar({ commit }) {
            return new Promise((resolve, reject) => {
                getCurAvatarUrl().then(res => {
                    commit('SET_AVATAR', res.data || null)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 设置当前用户头像
        SetAvatar(
            {
                commit,
                dispatch
            },
            data
        ) {
            return new Promise((resolve, reject) => {
                commit('SET_TOKEN', '')
                // commit('SET_PERM_LIST', [])
                setCurAvatar(data).then(res => {
                    dispatch('GetAvatar')
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js